const join = (...parts) => parts.filter(Boolean).join(' · ');

export const ADMIN_TABS = [
  {
    key: 'bookings',
    label: 'Bookings',
    path: 'bookings',
    dateKey: 'timestamp',
    title: (r) => `${r.firstName} ${r.lastName}`,
    subtitle: (r) => join(`${r.printerBrand} ${r.printerModel}`, r.serviceType, r.urgency, r.customerState, r.pageSource),
  },
  {
    key: 'technicians',
    label: 'Technician applications',
    path: 'technician-applications',
    dateKey: 'createdAt',
    title: (r) => r.fullName,
    subtitle: (r) => join(`${r.suburb}, ${r.state}`, `${r.yearsExperience} yrs`, r.reviewStatus?.replace(/_/g, ' ')),
  },
  {
    key: 'leads',
    label: 'Checklist leads',
    path: 'checklist-leads',
    dateKey: 'createdAt',
    title: (r) => r.email,
    subtitle: (r) => join(r.schoolName, r.role, r.pageSlug),
  },
];

const HIDDEN_FIELDS = new Set(['id', 'emailSent', 'consent']);

export const formatLabel = (key) => key.replace(/([A-Z])/g, ' $1').replace(/^./, (c) => c.toUpperCase());

export const formatValue = (value) => {
  if (Array.isArray(value)) return value.join(', ') || '—';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (value === null || value === undefined || value === '') return '—';
  return String(value);
};

export const detailEntries = (record) => Object.entries(record).filter(([key]) => !HIDDEN_FIELDS.has(key));

export const formatDate = (value) => (value ? new Date(value).toLocaleString('en-AU', { dateStyle: 'medium', timeStyle: 'short' }) : '—');
